// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1pKbn","title":"AfterFrontImage_title__11QO8"};